import http from "./http-common";

const moduleList = {
  CAT_DASHBOARD: [
    "WEB_DB_001",
  ],
  CAT_APPLY: [
    "WEB_AP_001",
    "WEB_AP_002",
    "WEB_AP_003",
  ],
  CAT_APPS: [
    "APPS_001",
  ],
  CAT_HISTORY: [
    "WEB_HIS_001",
    "WEB_HIS_002",
    "WEB_HIS_003",
  ],
  CAT_USERS: [
    // "WEB_URS_001",
    "WEB_URS_002",
    "WEB_URS_003",
    "WEB_URS_004",
  ],
  CAT_MASTER: [
    "WEB_MST_001",
    "WEB_MST_002",
    "WEB_MST_003",
  ],
  CAT_PUBLIC: [
    "WEB_PUB_001",
  ]

// const PAGE_NAME = "Employee.js_";
// const MODULE_ID = "WEB_EMP_001";
// const PAGE_NAME = "Profile.js";
// const MODULE_ID = "WEB_PROFILE_001"
// const PAGE_NAME = "RoleLevelSettings.js";
// const MODULE_ID = "WEB_RLS_001";


};

const moduleBinary = {
  0: 0b0000000000000001,
  1: 0b0000000000000010,
  2: 0b0000000000000100,
  3: 0b0000000000001000,
  4: 0b0000000000010000,
  5: 0b0000000000100000,
  6: 0b0000000001000000,
  7: 0b0000000010000000,
  8: 0b0000000100000000,
  9: 0b0000001000000000,
  10: 0b0000010000000000,
  11: 0b0000100000000000,
  12: 0b0001000000000000,
  13: 0b0010000000000000,
  14: 0b0100000000000000,
  15: 0b1000000000000000,
};

function GetModuleList (moduleId) {
  return moduleList[moduleId];
}

function GetUserAuthorityFn(userId, moduleCat, moduleList) {
  let promise = new Promise(function (resolve, reject) {
    const listItems = [];
    let authority = 0b0000000000000000;
    try {
      http
        .get(
          `api/WebCommon/GetUserAuthority?_userId=${userId}&_moduleCat=${moduleCat}`,
          { timeout: 10000000 }
        )
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach((data, counter) => {
              listItems.push({
                MODULE_ID: data.MODULE_ID,
              });
            });
            moduleList.forEach((m, i) => {
              var module = listItems.filter((d) => d.MODULE_ID === m);
              if (module.length > 0) {
                authority = authority | moduleBinary[i];
              }
            });
          }
          resolve(authority);
        })
        .catch((err) => {
          reject(`Error on getting user authority list.`);
        });
    } catch (err) {
      reject(`Error on getting user authority list.`);
    }
  });
  return promise;
}

function GetPageAuthorityFn(userId, moduleId) {
  let promise = new Promise(function (resolve, reject) {
    var listItems = [];
    try {
      http
        .get(
          `api/WebCommon/GetPageAuthority?_userId=${userId}&_moduleId=${moduleId}`,
          { timeout: 100000 }
        )
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach((data, counter) => {
              listItems = {
                ...listItems,
                [data.FEATURE_TYPE]: data.AUTHORIZED,
              };
            });
          }
          resolve(listItems);
        })
        .catch((err) => {
          reject(`Error on checking user authority on ${moduleId}.`);
        });
    } catch (err) {
      reject(`Error on checking user authority on ${moduleId}.`);
    }
  });
  return promise;
}

function GetDashboardViewAllPermissionFn(userId, moduleId) {
  let promise = new Promise(function (resolve, reject) {
    var listItems = [];
    try {
      http
        .get(
          `api/permission/GetDashboardViewAllPermission?_userId=${userId}&_moduleId=${moduleId}`,
          { timeout: 100000 }
        )
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach((data, counter) => {
              listItems = {
                ...listItems,
                [data.FEATURE_DESC]: data.AUTHORIZED,
              };
            });
          }
          resolve(listItems);
        })
        .catch((err) => {
          reject(`Error on checking dashboard view all permission on ${moduleId}.`);
        });
    } catch (err) {
      reject(`Error on checking dashboard view all permission on ${moduleId}.`);
    }
  });
  return promise;
}

function GetApplyLeavePermissionFn(userId, moduleId) {
  let promise = new Promise(function (resolve, reject) {
    var listItems = [];
    try {
      http
        .get(
          `api/permission/GetApplyLeavePermissionFn?_userId=${userId}&_moduleId=${moduleId}`,
          { timeout: 100000 }
        )
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach((data, counter) => {
              listItems = {
                ...listItems,
                [data.FEATURE_DESC]: data.AUTHORIZED,
              };
            });
          }
          resolve(listItems);
        })
        .catch((err) => {
          reject(`Error on checking apply leave permission on ${moduleId}.`);
        });
    } catch (err) {
      reject(`Error on checking apply leave permission on ${moduleId}.`);
    }
  });
  return promise;
}

function GetLeaveHistoryActionPermission(userId, moduleId) {
  let promise = new Promise(function (resolve, reject) {
    var listItems = [];
    try {
      http
        .get(
          `api/permission/GetLeaveHistoryActionPermission?_userId=${userId}&_moduleId=${moduleId}`,
          { timeout: 100000 }
        )
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach((data, counter) => {
              listItems = {
                ...listItems,
                [data.FEATURE_DESC]: data.AUTHORIZED,
              };
            });
          }
          resolve(listItems);
        })
        .catch((err) => {
          reject(`Error on checking leave history action permission on ${moduleId}.`);
        });
    } catch (err) {
      reject(`Error on checking leave history action permission on ${moduleId}.`);
    }
  });
  return promise;
}

function GetAllowanceHistoryActionPermission(userId, moduleId) {
  let promise = new Promise(function (resolve, reject) {
    var listItems = [];
    try {
      http
        .get(
          `api/permission/GetAllowanceHistoryActionPermission?_userId=${userId}&_moduleId=${moduleId}`,
          { timeout: 100000 }
        )
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach((data, counter) => {
              listItems = {
                ...listItems,
                [data.FEATURE_DESC]: data.AUTHORIZED,
              };
            });
          }
          resolve(listItems);
        })
        .catch((err) => {
          reject(`Error on checking allowance history action permission on ${moduleId}.`);
        });
    } catch (err) {
      reject(`Error on checking alowance history action permission on ${moduleId}.`);
    }
  });
  return promise;
}

function GetExpensesHistoryActionPermission(userId, moduleId) {
  let promise = new Promise(function (resolve, reject) {
    var listItems = [];
    try {
      http
        .get(
          `api/permission/GetExpensesHistoryActionPermission?_userId=${userId}&_moduleId=${moduleId}`,
          { timeout: 100000 }
        )
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach((data, counter) => {
              listItems = {
                ...listItems,
                [data.FEATURE_DESC]: data.AUTHORIZED,
              };
            });
          }
          resolve(listItems);
        })
        .catch((err) => {
          reject(`Error on checking expenses history action permission on ${moduleId}.`);
        });
    } catch (err) {
      reject(`Error on checking expenses history action permission on ${moduleId}.`);
    }
  });
  return promise;
}

export { moduleBinary, GetUserAuthorityFn, GetPageAuthorityFn, GetModuleList, GetDashboardViewAllPermissionFn, GetApplyLeavePermissionFn, GetLeaveHistoryActionPermission, GetAllowanceHistoryActionPermission, GetExpensesHistoryActionPermission};
